import React from 'react';
import Editor from '@monaco-editor/react';
import './SurveyThemeOption.scss';
import { Spin } from 'antd';

function ThemeCSSEditor(props) {
  return (
    <Editor
      {...props}
      language="css"
      className="css-editor"
      height="500px"
      loading={<Spin spinning />}
      options={{
        readOnly: props.editMode,
        automaticLayout: true,
        codeLens: false,
        colorDecorators: true,
        formatOnType: true,
        contextmenu: false,
        disableLayerHinting: true,
        folding: false,
        scrollBeyondLastLine: false,
        fontLigatures: true,
        formatOnPaste: true,
        highlightActiveIndentGuide: false,
        links: false,
        overviewRulerBorder: false,
        overviewRulerLanes: 0,
        renderControlCharacters: false,
        renderIndentGuides: true,
        renderLineHighlight: 'none',
        renderWhitespace: 'none',
        showFoldingControls: 'never',
        wordWrapMinified: true,
        minimap: {
          enabled: false,
          autohide: true,
        },
      }}
    />
  );
}

export { ThemeCSSEditor };
